import React from 'react';

import { L10n } from '../../components/L10n';
import Typography from '../../components/Typography';
import Link from '../../components/Link';
import { Box } from '../../components/Box';

const shinglesDisclaimer = {
  disclaimer: (
    <Typography variant={['textVariant']}>
      <L10n tokenID="disclaimer.shingles" />
    </Typography>
  ),
  disclaimerChecked: false,
};

const covidDisclaimer = {
  disclaimer: (
    <Typography variant={['textVariant']}>
      <L10n tokenID="disclaimer.covid_1" />
      <Link href="https://www.cdc.gov/covid/risk-factors/index.html" external>
        <L10n tokenID="disclaimer.covid_link" />
      </Link>
      <L10n tokenID="disclaimer.covid_2" />
    </Typography>
  ),
  disclaimerChecked: false,
};

const rsvDisclaimer = {
  disclaimer: (
    <div>
      <Box marginBottom="8px">
        <Typography variant={['textVariant']}>
          <L10n tokenID="disclaimer.rsv_1" />
        </Typography>
      </Box>
      <Box marginLeft="16px" marginBottom="8px">
        <Box marginBottom="4px">
          <Typography variant={['textVariant']}>
            <L10n tokenID="disclaimer.rsv_2" />
          </Typography>
        </Box>
        <Box marginBottom="4px">
          <Typography variant={['textVariant']}>
            <L10n tokenID="disclaimer.rsv_3" />
            <Link href="https://www.cdc.gov/rsv/vaccines/adults.html" external>
              <L10n tokenID="disclaimer.rsv_link" />
            </Link>
            <L10n tokenID="disclaimer.rsv_4" />
          </Typography>
        </Box>
        <Typography variant={['textVariant']}>
          <L10n tokenID="disclaimer.rsv_5" />
        </Typography>
      </Box>
    </div>
  ),
  disclaimerChecked: false,
};

const yellowFeverDisclaimer = {
  disclaimer: (
    <Typography variant={['textVariant']}>
      <L10n tokenID="disclaimer.yellow_fever" />
    </Typography>
  ),
  disclaimerChecked: false,
};

export const disclaimerSpecs = () => ({
  shingles: shinglesDisclaimer,
  'COVID-19': covidDisclaimer,
  RSV: rsvDisclaimer,
  'yellow fever': yellowFeverDisclaimer,
});
